import type { FC } from 'react';

import { OxxioLogo } from '@eneco/sparky';

import { BrandLogo } from './Logo';

/**
 * `Logo` block of the Oxxio container on the CMS-agnostic lane, serving **both** providers. Mirrors
 * `libs/sitecore/components/oxxio/src/ImageLink/ImageLink.tsx`, which Oxxio registers as its `Logo`: the
 * Oxxio mark, linked, with the link's text as its hidden label (and, as legacy, no label without one).
 */
const LogoOxxio: FC = () => <BrandLogo mark={<OxxioLogo />} />;

export default LogoOxxio;
